<template>
    <component v-if="!isHidden()" :is="config.component" v-model="setting.Value" :disabled="config.disabled"
        :list="list" :textkey="'Text'" :valuekey="'Id'" :label="label"
        :type="isPassword() ? 'password' : 'text'"
        :placeholder="placeholder" externaledit :rules="rules"
        :clearable="config.clearable" :hint="hint" :persistentHint="!!hint" :loading="isLoading">
    </component>
</template>


<script>
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";

export default {
    name: "ERPIntegrationSettingRow",
    props: {
        isLoading: Boolean,
        setting: Object,
    },
    components: {},
    mixins: [QInputRuleMixin],

    data() {
        return {
            modeToComponentConfigObj: {
                Editable: {
                    component: 'QTextField',
                    disabled: false,
                    clearable: this.setting.IsRequired,
                },
                EditableSelection: {
                    component: 'QAutoComplete',
                    disabled: false,
                    clearable: this.setting.IsRequired,
                },
                Password: {
                    component: 'QTextField',
                    disabled: false,
                    clearable: this.setting.IsRequired,
                },
                ReadOnly: {
                    component: 'QTextField',
                    disabled: true,
                    clearable: false,
                },
                Hidden: {
                    component: 'QTextField',
                    disabled: true,
                    clearable: false,
                },
            },
        };
    },

    methods: {
        isHidden() {
            return this.setting.Property.Mode == 'Hidden';
        },

        isPassword() {
            return this.setting.Property.Mode == 'Password';
        },

        isClearable(item) {
            return !item.Property.IsRequired;
        },
    },

    computed: {
        config() {
            return this.modeToComponentConfigObj[this.setting.Property.Mode];
        },

        rules() {
            return !this.config.clearable ? [this.requiredRule] : [];
        },

        placeholder() {
            return this.setting.Property.DefaultValue;
        },

        hint() {
            if (this.list) {
                return this.setting.Property.DefaultValue && 'Default: ' + this.list.find(x => x.Id === this.setting.Property.DefaultValue)?.Text;
            }
            return this.setting.Property.DefaultValue && 'Default: ' + this.setting.Property.DefaultValue;
        },

        list() {
            return this.setting.Property.Selection;
        },

        label() {
            return this.setting.Property.Description || this.setting.Property.Name;
        },
    },

    watch: {},
};
</script>


<style lang="scss" scoped></style>